/**
 * Link templates for multilang docs
 */
export const publicBucketRoot =
    'https://boxyland.s3.eu-west-3.amazonaws.com/public/'
export const documentLinks = {
    gdpr: publicBucketRoot + 'docs//{country}_PRIVACYPOLICY_{lang}.pdf',
    tradingTerms:
        publicBucketRoot +
        'docs/{country}_TERMSCONDITIONS_{lang}.pdf',
    paymentTerms: publicBucketRoot + 'docs/GoPay%20podmienky_{lang}.pdf'
}
